import { BaseModalProps, Modal } from '@/components/Modal';
import { useTranslation } from 'react-i18next';
import { RenewContractForm, RenewContractFormData } from './RenewContractForm';
import { RenewContractDto } from '@/lib/api/contracts';
import { Contract } from '@console/utils';

export interface RenewContractModalProps extends BaseModalProps {
  contract: Contract;
  onRenew: (data: RenewContractDto) => Promise<boolean>;
  isRenewing: boolean;
}

export function RenewContractModal({
  open,
  onOpenChange,
  contract,
  onRenew,
  isRenewing,
}: RenewContractModalProps) {
  const { t } = useTranslation();

  const handleSubmit = async (data: RenewContractFormData) => {
    const success = await onRenew({
      startDate: data.startDate,
      endDate: data.endDate,
      contractedHours: data.contractedHours,
      monthlyHoursLimit: data.monthlyHoursLimit,
      minDebitTime: data.minDebitTime,
      renewalNotes: data.renewalNotes,
    });

    if (success) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange} title={t('contracts.renewModal.title')}>
      <RenewContractForm
        originalContract={contract}
        onSubmit={handleSubmit}
        isLoading={isRenewing}
        onCancel={handleCancel}
      />
    </Modal>
  );
}
